import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

const getBrandLogo = (brand: string) => {
  switch (brand) {
    case 'visa':
      return 'fab fa-cc-visa';
    case 'mastercard':
      return 'fab fa-cc-mastercard';
    case 'amex':
      return 'fab fa-cc-amex';
    case 'jcb':
      return 'fab fa-cc-jcb';
    case 'discover':
      return 'fab fa-cc-discover';
    case 'diners-club':
      return 'fab fa-cc-diners-club';
    case 'amazon-pay':
      return 'fab fa-cc-amazon-pay';
    case 'paypal':
      return 'fab fa-cc-paypal';
    case 'stripe':
      return 'fab fa-stripe';
    case 'apple-pay':
      return 'fab fa-cc-apple-pay';
    default:
      return 'fas fa-credit-card';
  }
};

type Props = {
  defaultCardId: String,
  paymentMethods?: any[],
  onDelete: { (method: any): void },
  onSetDefault: { (method: any): void },
};

const CardsList = ({
  defaultCardId,
  paymentMethods = [],
  onDelete,
  onSetDefault,
}: Props) => (
  <>
    {paymentMethods?.map(method => (
      <Flex
        key={method.id}
        justify="space-between"
        width="100%"
        padding="10px"
        align="center"
      >
        <Flex
          spacing={10}
          align="center"
        >
          <S.CardIcon
            type={getBrandLogo(method.card.brand)}
          />
          <Text>
            {method.card.last4}
            ,
          </Text>
          <Text>
            {method.card.exp_month}
            /
            {method.card.exp_year}
          </Text>
        </Flex>
        <Flex align="center">
          <Text>{method.billing_details?.name}</Text>

          {(paymentMethods.length > 1 && defaultCardId !== method.id) && (
            <S.MakeDefaultButton
              onClick={() => onSetDefault(method)}
            >
              Make Default
            </S.MakeDefaultButton>
          )}

          <S.DeleteButton
            onClick={() => onDelete(method)}
          >
            delete
          </S.DeleteButton>
        </Flex>
      </Flex>
    ))}
  </>
);

export default CardsList;
